import { createAction } from "@reduxjs/toolkit";
import type { SubscriptionRequest } from "@somewear/api";

export const apiSubscriptionsSuccess = createAction<SubscriptionRequest.AsObject[]>(
	"app/apiSubscriptionsSuccess",
);

export const apiSubscriptionsError = createAction<SubscriptionRequest.AsObject[]>(
	"app/apiSubscriptionsError",
);
